<template>
  <div class="carousel-container">
    <!-- 整体边框 -->
    <div class="carousel-wrapper">
      <!-- 头部信息 -->
      <div class="header-info">
        <div class="person-info">
          <span class="name">NAME: {{ currentSlide.name }}</span>
          <span class="role">ROLE: {{ currentSlide.role }}</span>
        </div>
      </div>

      <!-- 主要内容区 -->
      <div class="main-content">
        <!-- 左侧人物图片 -->
        <div class="person-image">
          <img :src="currentSlide.personImage" :alt="currentSlide.name" />
        </div>

        <!-- 右侧内容 -->
        <div class="content-section">
          <div class="quote-image">
            <img :src="require('@/assets/imgsnew/page7-2.svg')" alt="Quote" />
          </div>
          <p class="quote-text">{{ currentSlide.quote }}</p>
        </div>
      </div>

      <!-- 底部控制区 -->
      <div class="carousel-controls">
        <button class="control-btn prev" @click="prevSlide">
          <img :src="require('@/assets/imgsnew/page7-3.svg')" alt="Previous" />
        </button>
        <div class="page-indicator">
          {{ currentIndex + 1 }}/{{ slides.length }}
        </div>
        <button class="control-btn next" @click="nextSlide">
          <img :src="require('@/assets/imgsnew/page7-4.svg')" alt="Next" />
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "LeadershipCarousel",
  data() {
    return {
      currentIndex: 0,
      slides: [
        {
          name: "HIS EXCELLENCY MOHAMED ABDULLAH",
          role: "CEO",
          personImage: require("@/assets/imgsnew/div.png"),
          quote:
            "Welcome to Sharjah Islamic Bank, the largest bank in Sharjah and the first bank in the world to successfully convert from a conventional bank to an Islamic bank, providing the group with Islamic products and services that comply with Shariah regulations. Sharjah Islamic Bank is an integral part of the UAE national economic environment and as such we aspire to realize the vision and aspirations of our wise leadership",
        },
        {
          name: "JOHN DOE",
          role: "CFO",
          personImage: require("@/assets/imgsnew/page7-5.svg"),
          quote:
            "Our commitment to excellence and innovation drives us to continuously improve our services and deliver the best possible solutions to our valued customers. We believe in building lasting relationships based on trust and mutual respect.",
        },
        // 可以添加更多数据...
      ],
    };
  },
  computed: {
    currentSlide() {
      return this.slides[this.currentIndex];
    },
  },
  methods: {
    nextSlide() {
      this.currentIndex = (this.currentIndex + 1) % this.slides.length;
    },
    prevSlide() {
      this.currentIndex =
        this.currentIndex === 0
          ? this.slides.length - 1
          : this.currentIndex - 1;
    },
  },
};
</script>

<style scoped>
.carousel-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  padding: 20px;
}

.carousel-wrapper {
  width: 1000px;
  height: 500px;
  border: 1px solid #000;
  position: relative;
  display: flex;
  flex-direction: column;
}

.header-info {
  border-bottom: 1px solid #000;
  padding: 12px 30px;
  flex-shrink: 0;
}

.person-info {
  display: flex;
  justify-content: space-between;
  font-size: 16px;
  font-weight: 500;
}

.name,
.role {
  text-transform: uppercase;
}

.main-content {
  display: flex;
  padding: 25px 30px;
  gap: 60px;
  border-bottom: 1px solid #000;
  flex: 1;
  overflow: hidden;
}

.person-image {
  flex: 0.8;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-right: 0;
  border-right: none;
}

.person-image img {
  width: 100%;
  height: auto;
  max-width: 320px;
  object-fit: contain;
}

.content-section {
  flex: 1.2;
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding-left: 0;
}

.quote-image {
  width: 50px;
  margin-bottom: 15px;
}

.quote-image img {
  width: 100%;
  height: auto;
}

.quote-text {
  font-size: 18px;
  line-height: 1.6;
  color: #333;
}

.carousel-controls {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 30px;
  flex-shrink: 0;
}

.control-btn {
  background: none;
  border: none;
  cursor: pointer;
  padding: 10px;
}

.control-btn img {
  width: 30px;
  height: auto;
}

.page-indicator {
  font-size: 18px;
  font-weight: 500;
}

@media (max-width: 1280px) {
  .carousel-wrapper {
    width: 100%;
    max-width: 1000px;
    height: auto;
    min-height: 500px;
  }
}

@media (max-width: 768px) {
  .carousel-wrapper {
    margin: 0 10px;
    min-height: auto;
  }

  .main-content {
    flex-direction: column;
    gap: 30px;
    padding: 20px;
  }

  .person-image {
    border-bottom: 1px solid #000;
    padding-bottom: 20px;
  }

  .person-image img {
    max-width: 280px;
  }

  .content-section {
    padding-left: 0;
  }

  .person-info {
    flex-direction: column;
    gap: 10px;
    align-items: flex-start;
  }

  .quote-text {
    font-size: 16px;
  }

  .carousel-controls {
    padding: 20px;
  }
}
</style>
